module.exports = __webpack_public_path__ + "media/images/activate/indeed-97dc36a9f776bd294106302c892acfc0.png";